import React, {Component} from 'react';

export default class InactiveStudent extends Component {
	render() {
		document.body.classList.add("pace-done");
		return (
			<section>
				<div>
					<h1>Votre compte n'est pas encore activé. Nous vous invitons à réessayer dans 24 heures. Si le
						problème persiste, merci de contacter le secrétariat académique.</h1>
				</div>
			</section>
		);
	}
}
